import PersonalInformation from './PersonalInformation.page';

export default PersonalInformation;
